import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      // Correctif visibilite (retour d'usage, 07/09/2026) : --input (utilise
      // par bg-input) vaut 91.4% de luminosite dans index.css - quasi blanc,
      // donc l'etat "desactive" du switch etait pratiquement invisible sur
      // une carte blanche (ex: bloc teleconsultation du tableau de bord).
      // Un premier essai avec un gris plus fonce (#CBD5E1, slate-300) restait
      // encore trop pale au retour d'usage - on passe a #94A3B8 (slate-400,
      // nettement plus contraste) ET on ajoute une bordure visible en
      // permanence (au lieu de border-transparent) pour que le contour du
      // switch se voie meme si le fond ne suffit pas.
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:border-primary data-[state=unchecked]:bg-[#94A3B8] data-[state=unchecked]:border-[#94A3B8]",
      className
    )}
    {...props}
    ref={ref}>
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
      )} />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
